'use strict';

var React = require('react');

var SvgPlanMajor = function SvgPlanMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 1a2 2 0 0 0-2 2v3h-2a2 2 0 0 0-2 2v3h-2a2 2 0 0 0-2 2v3c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2v-13a2 2 0 0 0-2-2h-6Zm0 2h5v3h-5v-3Zm-4 5h5v3h-5v-3Zm-4 5h5v3h-5v-3Z"
  }));
};

exports.SvgPlanMajor = SvgPlanMajor;
